<template>
  <div class="admin-view">
    <div class="admin-header">
      <h2>Панель администратора</h2>
      <div class="tabs">
        <button :class="{ active: tab === 'vectorStores' }" @click="setTab('vectorStores')">Vector Store</button>
        <button :class="{ active: tab === 'files' }" @click="setTab('files')">Файлы</button>
        <button :class="{ active: tab === 'settings' }" @click="setTab('settings')">Настройки</button>
        <button :class="{ active: tab === 'documentation' }" @click="setTab('documentation')">Документация</button>
        <button :class="{ active: tab === 'instructions' }" @click="setTab('instructions')">Инструкции</button>
      </div>
      <a href="#" class="chat-link" @click.prevent="$emit('goToChat')">Перейти в чат</a>
      <a href="#" class="logout-link" @click.prevent="logout">Выйти</a>
    </div>

    <div class="admin-body">
      <keep-alive>
        <vector-store-list v-if="tab === 'vectorStores'" :documentationVectorStoreId="documentationVectorStoreId" @used="documentationVectorStoreId = $event" />
        <file-list v-else-if="tab === 'files'" />
        <settings-editor v-else-if="tab === 'settings'" />
        <documentation-panel v-else-if="tab === 'documentation'" />
        <instructions-editor v-else-if="tab === 'instructions'" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { adminApi } from './api/admin-api';
import vectorStoreList from './admin/vector-store-list.vue';
import fileList from './admin/file-list.vue';
import settingsEditor from './admin/settings-editor.vue';
import documentationPanel from './admin/documentation-panel.vue';
import instructionsEditor from './admin/instructions-editor.vue';

export default {
  components: { vectorStoreList, fileList, settingsEditor, documentationPanel, instructionsEditor },
  data() {
    return {
      tab: 'vectorStores',
      documentationVectorStoreId: '',
    };
  },
  methods: {
    logout() {
      localStorage.removeItem('USER_NAME');
      localStorage.removeItem('ADMIN_PASSWORD');
      window.location.reload();
    },
    // Tab switches push a history entry so the browser's Back button moves between admin
    // sections (e.g. Документация -> Vector Store) instead of leaving the page entirely.
    setTab(tab) {
      if (this.tab === tab) return;
      this.tab = tab;
      history.pushState({ adminTab: tab }, '');
    },
    onPopState(event) {
      this.tab = (event.state && event.state.adminTab) || 'vectorStores';
    },
  },
  async mounted() {
    history.replaceState({ adminTab: this.tab }, '');
    window.addEventListener('popstate', this.onPopState);

    try {
      const { data } = await adminApi.get('/settings/documentationVectorStoreId');
      this.documentationVectorStoreId = data;
    } catch (e) {
      // non-fatal — vector-store-list just won't show the "in use" badge
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopState);
  },
};
</script>

<style scoped>
.admin-view {
  height: 100%;
  overflow-y: auto;
  text-align: left;
}

.admin-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
  background: #f7f7f7;
  position: sticky;
  top: 0;
  z-index: 1;
}

.admin-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.tabs {
  display: flex;
  gap: 8px;
  flex: 1;
}

.tabs button {
  background: none;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}

.tabs button.active {
  background: #f15540;
  color: white;
  border-color: #f15540;
}

.chat-link,
.logout-link {
  color: #006eff;
  font-size: 12px;
  white-space: nowrap;
}

.admin-body {
  max-width: 1000px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin-view.vue